import { render, staticRenderFns } from "./DepartmentEdit.vue?vue&type=template&id=725293b9&"
import script from "./DepartmentEdit.vue?vue&type=script&lang=js&"
export * from "./DepartmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports